import {
  AtoResumo,
  BoletimResumo,
  SlaDashboardDto,
} from '../models/boletim.model';

export const SLA_DASHBOARD_FIXTURE: SlaDashboardDto = {
  tempoMedioMinutos: 1440,
  tempoMedioRevisaoMinutos: 120,
  tempoMedioAssinaturaMinutos: 300,
  tempoMedioPublicacaoMinutos: 1020,
  volumePorOrigem: {
    movimentacao: 145,
    promocao: 89,
    disciplinar: 34,
    afastamento: 56,
    'tempo-servico': 28,
    organizacao: 12,
  },
  volumePorTipoBoletim: {
    BI: 180,
    BCG: 120,
    BRCG: 42,
    BI_RES: 22,
  },
};

export const ATOS_FILA_REVISAO_FIXTURE: AtoResumo[] = [
  {
    id: '1',
    tipoAto: 'TRANSFERENCIA',
    matriculasAfetadas: ['10.2030.040506'],
    estado: 'AGUARDANDO_REVISAO',
    dataVigencia: '2026-06-15',
    tipoBoletimSolicitado: 'BI',
    correlationId: 'corr-1',
    criadoEm: '2026-06-08T10:15:30Z',
  },
  {
    id: '2',
    tipoAto: 'PROMOCAO',
    matriculasAfetadas: ['11.4050.060708', '12.3040.506070'],
    estado: 'AGUARDANDO_REVISAO',
    dataVigencia: '2026-06-21',
    tipoBoletimSolicitado: 'BCG',
    correlationId: 'corr-2',
    criadoEm: '2026-06-08T14:32:00Z',
  },
  {
    id: '3',
    tipoAto: 'PUNICAO',
    matriculasAfetadas: ['09.1020.304050'],
    estado: 'AGUARDANDO_REVISAO',
    dataVigencia: '2026-06-09',
    tipoBoletimSolicitado: 'BRCG',
    correlationId: 'corr-3',
    criadoEm: '2026-06-09T08:12:15Z',
  },
  {
    id: '4',
    tipoAto: 'AVERBACAO',
    matriculasAfetadas: ['08.1122.334455'],
    estado: 'AGUARDANDO_REVISAO',
    dataVigencia: '2026-06-09',
    tipoBoletimSolicitado: 'BI',
    correlationId: 'corr-4',
    criadoEm: '2026-06-09T09:05:41Z',
  },
];

export const ATOS_FILA_ASSINATURA_FIXTURE: AtoResumo[] = [
  {
    id: '10',
    tipoAto: 'PROMOCAO',
    matriculasAfetadas: ['11.4050.060708'],
    estado: 'REVISADO',
    dataVigencia: '2026-06-20',
    tipoBoletimSolicitado: 'BCG',
    correlationId: 'corr-10',
    criadoEm: '2026-06-07T09:20:00Z',
  },
  {
    id: '11',
    tipoAto: 'TRANSFERENCIA',
    matriculasAfetadas: ['09.2233.445566'],
    estado: 'REVISADO',
    dataVigencia: '2026-06-18',
    tipoBoletimSolicitado: 'BI',
    correlationId: 'corr-11',
    criadoEm: '2026-06-08T11:05:00Z',
  },
];

export const ATOS_ASSINADOS_FIXTURE: AtoResumo[] = [
  {
    id: '20',
    tipoAto: 'TRANSFERENCIA',
    matriculasAfetadas: ['10.2030.040506'],
    estado: 'ASSINADO',
    dataVigencia: '2026-06-15',
    tipoBoletimSolicitado: 'BI',
    correlationId: 'corr-20',
    criadoEm: '2026-06-08T10:15:30Z',
  },
  {
    id: '21',
    tipoAto: 'PROMOCAO',
    matriculasAfetadas: ['11.4050.060708'],
    estado: 'ASSINADO',
    dataVigencia: '2026-06-21',
    tipoBoletimSolicitado: 'BCG',
    correlationId: 'corr-21',
    criadoEm: '2026-06-08T14:32:00Z',
  },
  {
    id: '22',
    tipoAto: 'AVERBACAO',
    matriculasAfetadas: ['08.1122.334455'],
    estado: 'ASSINADO',
    dataVigencia: '2026-06-09',
    tipoBoletimSolicitado: 'BI',
    correlationId: 'corr-22',
    criadoEm: '2026-06-09T09:05:41Z',
  },
  {
    id: '23',
    tipoAto: 'PUNICAO',
    matriculasAfetadas: ['09.1020.304050'],
    estado: 'ASSINADO',
    dataVigencia: '2026-06-09',
    tipoBoletimSolicitado: 'BRCG',
    correlationId: 'corr-23',
    criadoEm: '2026-06-09T08:12:15Z',
  },
];

export const BOLETINS_PUBLICADOS_FIXTURE: BoletimResumo[] = [
  { id: '100', tipo: 'BI', numero: 104, ano: 2026, dataPublicacao: '2026-06-09', estado: 'PUBLICADO' },
  { id: '101', tipo: 'BCG', numero: 50, ano: 2026, dataPublicacao: '2026-06-08', estado: 'PUBLICADO' },
  { id: '102', tipo: 'BRCG', numero: 12, ano: 2026, dataPublicacao: '2026-06-07', estado: 'PUBLICADO' },
  { id: '103', tipo: 'BI_RES', numero: 8, ano: 2026, dataPublicacao: '2026-06-05', estado: 'PUBLICADO' },
];

export const TODOS_ATOS_FIXTURE: AtoResumo[] = [
  ...ATOS_FILA_REVISAO_FIXTURE,
  ...ATOS_FILA_ASSINATURA_FIXTURE,
  ...ATOS_ASSINADOS_FIXTURE,
];
